module.exports = __webpack_public_path__ + "static/media/poster5.8807c948.png";